import PropTypes from 'prop-types';
import questionTypes from '../questionTypes';
import createEmptyOptionCollection from '../../utils/createEmptyOptionCollection';
import personalLabelMap from '../../config/personalLabelMap';
import segmentLabelMap from '../../config/segmentLabelMap';
import getCommonBlockProps, { commentsProps } from './getCommonBlockProps';
import genericBlockPropTypes from './settings/genericBlockPropTypes';
import { DEFAULT_COL_LABEL } from './constants';
import { STYLING_KEY_QUESTION_TEXT } from '../../constants/stylingKey';

const { labelListEndMidpoint, labelListEnd, itemList } = segmentLabelMap;

export const blockPropTypes = {
  ...genericBlockPropTypes,
  size: PropTypes.string,
  shape: PropTypes.string,
  count: PropTypes.number,
  color: PropTypes.string,
  textColor: PropTypes.string,
  startFromZero: PropTypes.bool,
  personalLabelType: PropTypes.string,
  segment: PropTypes.string,
  itemList: PropTypes.array,
  labelListEnd: PropTypes.array,
  labelListEndMidpoint: PropTypes.array,
};

export const orderList = [
  {
    value: personalLabelMap.number,
    label: 'Ascending',
  },
  {
    value: personalLabelMap.numberDesc,
    label: 'Descending',
  },
];

export const shapeList = [
  {
    value: 'circle',
    label: 'Circle',
    listViewIconClassName: 'icon-custom-circle',
  },
  {
    value: 'rectangle',
    label: 'Rectangle',
    listViewIconClassName: 'icon-custom-rectangle',
  },
  {
    value: 'square',
    label: 'Square',
    listViewIconClassName: 'icon-custom-square',
  },
];

export const sizeList = [
  {
    value: 'small',
    label: 'Small',
    size: 13,
  },
  {
    value: 'medium',
    label: 'Medium',
    size: 16,
  },
  {
    value: 'large',
    label: 'Large',
    size: 18,
  },
];

export const defaultSize = sizeList[0].value;
export const defaultShape = shapeList[0].value;
export const initialRate = null;
export const defaultCount = 10;
const endMidpointLabelList = ['Bad', 'Good enough', 'Awesome'];
const endLabelList = ['Very unlikely', 'Very likely'];
const startFromZero = false;

const getDefaultProps = () => ({
  ...getCommonBlockProps(),
  ...commentsProps,
  size: defaultSize,
  shape: defaultShape,
  textColor: '#ffffff',
  startFromZero,
  personalLabelType: personalLabelMap.number,
  segment: labelListEnd,
  [itemList]: createEmptyOptionCollection(startFromZero ? defaultCount + 1 : defaultCount, DEFAULT_COL_LABEL),
  [labelListEnd]: createEmptyOptionCollection(endLabelList.length, endLabelList),
  [labelListEndMidpoint]: createEmptyOptionCollection(endMidpointLabelList.length, endMidpointLabelList),
});

const pickBlockPropsToInitialValues = ({
  color = null,
  commentsEnabled = null,
  itemList = [],
  logic: { isEnabled = null } = {},
  personalLabelType,
  required = null,
  segment = null,
  shape = null,
  size = null,
  startFromZero = null,
  textColor = null,
  type = null,
}) => ({
  color,
  commentsEnabled,
  itemList,
  logic: { isEnabled },
  personalLabelType,
  required,
  segment,
  shape,
  size,
  startFromZero,
  textColor,
  type,
});

export default {
  type: questionTypes.questionNumeric,
  getDefaultProps,
  pickBlockPropsToInitialValues,
  limits: {
    itemList: {
      max: 10,
      min: 3,
    },
  },
  settings: {
    defaultStylingEntity: STYLING_KEY_QUESTION_TEXT,
    blockPropTypes,
    isRequiredField: () => false,
    isUniqueField: () => false,
    isTextRequired: () => true,
  },
  toLogicOptions: (questions) =>
    Array.from({ length: questions.itemList.length }, (option, index) => {
      const value = questions.startFromZero ? index : index + 1;

      return {
        value,
        label: value,
        shape: questions.shape,
        color: questions.color,
      };
    }),
};
